<template>
  <router-view />

  <div class="toolbar">
    <div class="col-1 float-right">
      <new-menu-app></new-menu-app>
    </div>
    <back-icon></back-icon>
    <search-icon></search-icon>
    <div class="col-5 float-left">
      <v-img
          :src="require('../assets/logohome.png')"

          contain
          height="35"
      />
    </div>


  </div>
  <v-container  fluid class=" back">

    <v-row class="rowlogin">
      <v-col class="d-flex justify-center logo">
        <div style="border-radius: 50%;overflow: hidden;box-shadow: rgb(31, 162, 157) 0px 9px 10px;padding-top: 10px;width: 100px;height: 100px;text-align: center;margin-top: 70px">
          <i class="fa-solid fa-user"></i>
        </div>
      </v-col>
    </v-row>
    <v-row class="rowlogin">
      <v-col class="d-flex justify-center logo">
        <h3 style="color: #1fa29d">ویرایش کاربر</h3>
      </v-col>
    </v-row>
    <v-row class="rowlogin">
      <v-col class=" logo">
        <div class="form-group">
          <div class="col-4">
            نام
          </div>
          <div  class="col-8">
            <input type="text" class="form-control" dir="auto" v-model="name">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="col-4">
            نام خانوادگی
          </div>
          <div  class="col-8">
            <input type="text" class="form-control" dir="auto" v-model="family">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="col-4">
            ایمیل
          </div>
          <div  class="col-8">
            <input type="text" class="form-control" dir="auto" v-model="email">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="col-4">
            موبایل
          </div>
          <div  class="col-8">
            <input type="text" class="form-control" dir="auto" v-model="mobile" readonly>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="col-4">
            نام برند
          </div>
          <div  class="col-8">
            <input type="text" class="form-control" dir="auto" v-model="brand">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group" style="margin: 10px auto">
          <v-dialog max-width="500" transition="dialog-bottom-transition">
            <template v-slot:activator="{ props: activatorProps }">
              <div class="btn btn-success" v-bind="activatorProps" style="width: 100%;margin: 10px auto;background: rgb(31, 162, 157);" @click="updateProfile">ویرایش </div>

            </template>

            <template v-slot:default="{ isActive }">
              <v-card style="direction: rtl" :title="'اخطار'">
                <v-divider/>
                <v-card-text>
                  برای ویرایش اطلاعات لطفا با پشتبانی گالری تماس بگیرید.
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>

          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
      </v-col>
    </v-row>

  </v-container>
  <footer-app selectedItem="4"></footer-app>
</template>
<script >

import http from "@/plugins/axios";
import FooterApp from "@/views/FooterApp.vue";
import NewMenuApp from "@/components/newMenuApp.vue";
import SearchIcon from "@/components/searchIcon.vue";
import BackIcon from "@/components/backIcon.vue";
export default {
  name: 'profile',
  components: {BackIcon, SearchIcon, NewMenuApp, FooterApp},
  data: () => ({
    isActive : false,
    name : "",
    family : "",
    mobile : "",
    email : "",
    brand : "",

  }),
  methods:{
    updateProfile(){

      this.isActive=true;
      /*
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/update-user",{
        name : this.name,
        family : this.family,
        email : this.email,
        brand : this.brand,
      },{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.name = response.data.data.name;
            this.family = response.data.data.family;
            this.mobile = response.data.data.phone;
            this.email = response.data.data.email;
            this.brand = response.data.data.brand;
            this.$toast.success("پروفایل شما با موفقیت آپدیت شد")
          })
          .catch((error) => {
          });
          */

    },
    getUser(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/user",'',{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.name = response.data.data.name;
            this.family = response.data.data.family;
            this.mobile = response.data.data.phone;
            this.email = response.data.data.email;
            this.brand = response.data.data.brand;
          })
          .catch((error) => {
          });
    }
  },
  mounted() {
    this.getUser();
  },
}
</script>



<style scoped>
.toolbar{
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000000;
  direction: rtl;
  padding: 20px 30px;
  color: #fff;
  background: #fff;
}
.toolbar i{
  font-size: 24pt;
  color: #1fa29d;
}
.toolbar .col-9{
  padding-right: 10px;
}
.back{
  background-color: #fff;
  background-image: url('../assets/profileback.jpg');
  //background-position: right center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}
i.fa-user{
  font-size: 72pt;
  color:#1fa29d
}
.rowlogin .form-group{
  margin: 10px auto;
}
.rowlogin .form-group .col-4{
  text-align: left;
  padding-left: 10px;
  padding-top: 5px;
  font-size: 14pt;
  font-weight: 600;
}
.rowlogin .form-group input{
  background: none;
  border: 1px solid #1fa29d;
}
.rowlogin .form-group div{
  float: right;
}
.rowlogin .form-group{
  color:#1fa29d
}
.logo{
  min-width: 100%;
}
</style>